import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_RADIUS_PARSER_OPTIONS,
  RadiusParserOptions,
} from './radiusParserOptions.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getRadiusParserOptions(): AxiosPromise<ServerResponse<RadiusParserOptions>> {
  return http.get(`${API_PATH_RADIUS_PARSER_OPTIONS}/`);
}

export function updateRadiusParserOptions(
  id: string,
  body: WithAuditDetails<RadiusParserOptions>,
): AxiosPromise<ServerResponse<RadiusParserOptions>> {

  return http.put(`${API_PATH_RADIUS_PARSER_OPTIONS}/${id}`, body);
}

export function deleteRadiusParserOptions(
  id: string,
  body: WithAuditDetails<RadiusParserOptions>,
): AxiosPromise<ServerResponse<RadiusParserOptions>> {
  // NOTE: it was needed to wrap the body in a data field because DELETE method behhaviour
  return http.delete(`${API_PATH_RADIUS_PARSER_OPTIONS}/`, { data: body });
}

export function createRadiusParserOptions(
  body: WithAuditDetails<RadiusParserOptions>,
): AxiosPromise<ServerResponse<RadiusParserOptions>> {
  return http.post(`${API_PATH_RADIUS_PARSER_OPTIONS}/`, body);
}
